var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { constants, publicEncrypt } from 'crypto';
var KEYS_TO_SKIP_ENCRYPTION = [
    'employerId',
    'platformId',
    'id',
    'responseType',
    'edge_payload',
];
export function shouldEncryptKey(key) {
    return !KEYS_TO_SKIP_ENCRYPTION.includes(key);
}
export function encryptString(plaintext, publicKey) {
    var encryptedData = publicEncrypt({
        key: publicKey,
        padding: constants.RSA_PKCS1_OAEP_PADDING,
        oaepHash: 'sha512',
    }, Buffer.from(plaintext));
    var encryptedBase64 = encryptedData.toString('base64');
    return encryptedBase64;
}
export function encryptInBrowser(publicKeyPem, plaintext) {
    return __awaiter(this, void 0, void 0, function () {
        var pemHeader, pemFooter, pemContents, binaryDerString, binaryDer, i, publicKey, ciphertext, uintArray, string, base64;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // If the browser doesn't support the Web Crypto API, throw an error.
                    if (!window.crypto.subtle) {
                        throw new Error('Web Crypto API not supported in this browser');
                    }
                    pemHeader = '-----BEGIN PUBLIC KEY-----';
                    pemFooter = '-----END PUBLIC KEY-----';
                    pemContents = publicKeyPem.substring(pemHeader.length, publicKeyPem.length - pemFooter.length);
                    binaryDerString = window.atob(pemContents);
                    binaryDer = new Uint8Array(binaryDerString.length);
                    for (i = 0; i < binaryDerString.length; i++) {
                        binaryDer[i] = binaryDerString.charCodeAt(i);
                    }
                    return [4 /*yield*/, window.crypto.subtle.importKey('spki', binaryDer, {
                            name: 'RSA-OAEP',
                            hash: { name: 'SHA-512' },
                        }, true, ['encrypt'])];
                case 1:
                    publicKey = _a.sent();
                    return [4 /*yield*/, window.crypto.subtle.encrypt({
                            name: 'RSA-OAEP',
                        }, publicKey, Buffer.from(plaintext))];
                case 2:
                    ciphertext = _a.sent();
                    uintArray = new Uint8Array(ciphertext);
                    string = String.fromCharCode.apply(null, uintArray);
                    base64 = btoa(string);
                    return [2 /*return*/, base64];
            }
        });
    });
}
